export default __webpack_public_path__ + "static/media/Wardrobe and Beds SOBH.093eb1bf.jpg";